import React from 'react';
import cn from 'classnames';
import { Dropdown, Row, Upload, message, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

import ButtonClose from '../common/UI/ButtonClose';

import Icon from '../common/UI/Icon';

import PRIVILEGE_CODES from '../../configs/privilegeCodes';
import RESOURCE_TYPES from '../../configs/resourceTypes';
import { checkAccessOnObject } from '../../utils/rights';

import catalogActions from '../../actions/catalogActions';

import styles from './manual.less';

class ManualActions extends React.PureComponent {
  constructor() {
    super();
  }

  static propTypes = {
    catalog: PropTypes.object,
    scene: PropTypes.object,
    viewId: PropTypes.string,
    sceneId: PropTypes.string,
  };


  getDropDownButtons = () => {
    const { catalog, viewId, recordsCount, t, sceneViews, catalogView } = this.props;
    
    let dropDownButtonItems = [];

    // cancel edit button
    /* ----------------------------------------------------------------------- */

    const isEditing = catalog.get("manualIsEditing");
    if (isEditing) {
      dropDownButtonItems = [
        {
          text: t('buttons.abort'),
          icon: 'interface-5',
          onClick: this.onCancel
        },
      ].concat(dropDownButtonItems);
    }

    const dropdownMenu = dropDownButtonItems.map((item, i) => ({
          key: i,
          className: cn({ [styles.dropDownButton]: !item.disabled }),
          disabled: item.disabled,
          label: (
            <a onClick={item.onClick} className={item.className}>
              {item.icon ? <Icon type={`icon ${item.icon}`} className={styles.settingIcon} /> : null}
              {item.text}
            </a>
          ),
        }));

    return dropdownMenu;
  };

  
  onEdit = () => {
    const catalogId = this.props.catalog.get("id")
    catalogActions.manualEdit(catalogId);
  }

  onSave = () => {
    const catalogId = this.props.catalog.get("id")
    catalogActions.manualSave(catalogId);
  }

  onCancel = () => {
    const catalogId = this.props.catalog.get("id")
    catalogActions.manualCancelEdit(catalogId);
  }


  render() {
    const { scene, catalog, onClose, withCross, viewId, t } = this.props;

    const dropDownButtonItems = this.getDropDownButtons();
    const allowEdit = checkAccessOnObject(RESOURCE_TYPES.CATALOG, catalog, PRIVILEGE_CODES.ACCESS);
    const isEditing = catalog.get("manualIsEditing");
    const isSaving = catalog.get("manualIsSaving");

    return (
      <Row>
        {allowEdit ? (
            isEditing ?
            (
              <Dropdown.Button
                trigger={['click']}
                type="primary"
                overlayClassName={styles.dropDownMenu}
                onClick={this.onSave}
                menu={{ items: dropDownButtonItems }}
                style={{ marginLeft: '10px' }}
                icon={<DownOutlined />}
                disabled={isSaving}
                >
                {isSaving ? t('buttons.saving') : t('buttons.save')}
              </Dropdown.Button>
            ) : (
              <Button
              type="primary"
                onClick={this.onEdit}
                style={{ marginLeft: '10px' }}
                >
                {t('buttons.edit') }
              </Button>
            )
            
        ) : (null)}
        {withCross && <ButtonClose onClick={onClose} shiftRight />}
      </Row>
    );
  }
}
export default withTranslation()(
    ManualActions,
);
